import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import Image from 'react-retina-image';

import styles from './Nav.module.scss';
import { BRAND } from '../../constants/brand';
import { Link } from '..';
import { BOOKING_LINK } from '../../constants/booking';

interface NavProps {
  className?: string;
  location: object;
  navOpen: boolean;
  setNavOpen: any;
}

const Nav: FunctionComponent<NavProps> = ({
  className,
  navOpen,
  children,
  setNavOpen,
}) => {
  const navClass = classNames(`${BRAND.SUPER_SHORT_NAME}-nav`, className, {
    [styles.nav]: true,
    [styles.navOpen]: navOpen,
  });

  const logoClass = classNames({
    [styles.logo]: true,
    [styles.hide]: !navOpen,
  });

  return (
    <>
      <nav className={navClass}>
        <ul>
          <li className={styles.home}>
            <Link noStyles to="/" onClick={() => setNavOpen(false)}>
              Home
            </Link>
          </li>
          <li className={styles.order1}>
            <Link noStyles to="/prices" onClick={() => setNavOpen(false)}>
              Price List
            </Link>
          </li>
          <li className={styles.order2}>
            <Link noStyles to="/training" onClick={() => setNavOpen(false)}>
              Training Courses
            </Link>
          </li>
          <li className={styles.order3}>
            <Link noStyles to="/faq" onClick={() => setNavOpen(false)}>
              FAQ
            </Link>
          </li>
          <li className={styles.booking}>
            <Link noStyles external to={BOOKING_LINK}>
              Booking
            </Link>
          </li>
          <li className={styles.contact}>
            <Link noStyles to="/contact" onClick={() => setNavOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>
      {children}
      <Image
        src="/images/logo.png"
        alt="Crystal Canine"
        className={logoClass}
      />
    </>
  );
};

export default Nav;
